import BaseValidator      from '@/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/lib/data/validator/ValidatorTypesEnum'

export default class ChangePasswordValidator extends BaseValidator {
  validatorRules = {
    CurrentPassword: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 6,
      maxLen  : 16
    },
    Password: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 6,
      maxLen  : 16
    },
    ConfirmPassword: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 6,
      maxLen  : 16,
      equals  : 'Password'
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
